const unSnakeKey = <S extends PropertyKey>(key: S) => {
    if (typeof key !== 'string') {
        return key;
    }
    return key.replace(/_([a-z])/g, (_, $1) => $1.toUpperCase());
};

// TODO-3783: this begs for unit test
export const unSnakeByMutation = <T>(thing: T): unknown => {
    if (thing === null || typeof thing !== 'object') {
        return thing;
    }
    if (Array.isArray(thing)) {
        for (const subThing of thing) {
            unSnakeByMutation(subThing);
        }
    }
    for (const [key, value] of Object.entries(thing)) {
        Reflect.deleteProperty(thing, key);
        Reflect.set(thing, unSnakeKey(key), unSnakeByMutation(value));
    }
    return thing;
};
